<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import VLazyImage from "v-lazy-image/v2";

// Custom Components
import PageHeader from "@/components/page-header";
import Floor from "@/components/inventory/floor.vue";
import UserService from "@/helpers/APIService/user.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Floor section Component

export default {
  page: {
    title: "Floor Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    Floor,
    PageHeader,
    VLazyImage,
  },
  data() {
    return {
      title: "Floor",
      isLoading: true,
      editable: true,
      isDragging: false,
      table: {
        tableData: [],
      },
      openFloorDrawer: false,
      selectedFloor: null,
      submitted: null,
      isEdit: false,
    };
  },
  computed: {
    ...authComputed,
    floorProps() {
      return {
        selectedFloor: this.selectedFloor,
        isEdit: this.isEdit,
      };
    },
  },
  mounted() {
    // this.getFloorListData();
    this.$root.$on("updateImageStatusInFloor", (data) => {
      this.manageImageResponse(data, "updateImageStatusInFloor");
    });
    this.$root.$on("imageAddedInFloor", (data) => {
      this.manageImageResponse(data, "imageAddedInFloor");
    });
    this.$root.$on("removeImageInFloor", (data) => {
      this.manageImageResponse(data, "removeImageInFloor");
    });
  },
  methods: {
    async getFloorListData() {
      await UserService.getFloorList()
        .then((floor) => {
          this.table.tableData = floor;
          this.isLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    floorForm() {
      if (this.openFloorDrawer == true) {
        this.selectedFloor = null;
        this.isEdit = false;
      }
      this.openFloorDrawer = !this.openFloorDrawer;
    },
    // Method is use for update live data
    floorAddedUpdated(floor) {
      if (this.isEdit == true) {
        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id === floor.id) {
            item = floor;
          }
          return item;
        });
        Middleware.notification("Successfully updated !!", "success");
      } else {
        this.table.tableData.unshift(floor);
        Middleware.notification("Successfully added !!", "success");
      }
      this.floorForm();
    },
    saveAndAddNewFloor(floor) {
      this.table.tableData.unshift(floor);
      Middleware.notification("Successfully added !!", "success");
    },
    // Method is use for update floor based on ID
    edit(data) {
      this.selectedFloor = data;
      this.isEdit = true;
      this.floorForm();
    },
    // Method is use for delete floor
    deleteFloor(index, id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.value) {
          UserService.deleteFloor(id).then(
            () => {
              this.table.tableData.splice(index, 1);
              Middleware.notification("Successfully deleted !!", "warning");
            },
            (error) => {
              errorHandler(error);
            }
          );
        }
      });
    },
    // Method is used to manage drawer action response
    manageImageResponse(data, status) {
      this.table.tableData = this.table.tableData.map((item) => {
        if (item.id == data.floor) {
          if (status == "updateImageStatusInFloor") {
            item.floor_image = item.floor_image.map((img) => {
              if (img.id == data.id) {
                img.is_thumbnail = true;
              } else {
                img.is_thumbnail = false;
              }
              return img;
            });
          }
          if (status == "removeImageInFloor") {
            item.floor_image = item.floor_image.filter(
              (img) => img.id !== data.id
            );
          }
        }
        return item;
      });
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="title"
      :action="floorForm"
      text="Add New Floor"
      :isButton="true"
    />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <div class="table-responsive mb-0">
                  <!-- Table -->
                  <table
                    class="table table-hover mb-0 common-table"
                    ref="my-table"
                    v-infinite-scroll="getFloorListData"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                  >
                    <thead class="table-light">
                      <tr>
                        <th>Name</th>
                        <th>Short Name</th>
                        <th>Building Name</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody v-if="isLoading">
                      <tr v-for="(item, index) in 20" :key="index">
                        <td class="placeholder-glow" v-for="no in 4" :key="no">
                          <span class="placeholder w-100 placeholder-lg"></span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(data, index) in table.tableData" :key="index">
                        <td @click="edit(data)">
                          <div class="d-flex align-items-center">
                            <template v-for="image in data.floor_image">
                              <v-lazy-image
                                v-if="image.is_thumbnail"
                                :key="image.id"
                                :src="
                                  image.image.replace('upload', 'thumbs200')
                                "
                                alt=""
                                class="rounded-circle picture-img"
                              />
                            </template>
                            <img
                              v-if="data.floor_image.length == 0"
                              key="image"
                              src="@/assets/images/placeholder.png"
                              alt=""
                              class="rounded-circle picture-img"
                            />

                            <span class="text-truncate ms-2 d-block w-75">{{
                              data.name
                            }}</span>
                          </div>
                        </td>
                        <td @click="edit(data)">
                          {{ data.short_name }}
                        </td>
                        <td @click="edit(data)">
                          {{
                            data.building.short_name + "-" + data.building.name
                          }}
                        </td>
                        <td>
                          <div slot="actions" class="d-flex align-items-center">
                            <i
                              class="fas fa-pencil-alt text-success me-2"
                              v-b-popover.hover="'Edit floor'"
                              @click="edit(data)"
                            ></i>

                            <i
                              v-b-popover.hover="'Delete floor'"
                              class="mdi mdi-trash-can fs-5 text-danger"
                              @click="deleteFloor(index, data.id)"
                            ></i>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="!isLoading && table.tableData.length == 0">
                      <tr>
                        <td colspan="9" class="text-center">
                          <img
                            src="@/assets/images/empty.svg"
                            class="img-fluid"
                            alt=""
                          />
                          <p>
                            <span class="text-secondary">No Data Found</span>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Drawer is for add and update new floor -->
    <Drawer
      @close="floorForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
    >
      <div v-if="openFloorDrawer">
        <Floor
          :currentProps="floorProps"
          @submitted="floorAddedUpdated"
          @cancelSubmit="floorForm"
          @saveAndAddNew="saveAndAddNewFloor"
        />
      </div>
    </Drawer>
  </div>
</template>
